import * as React from 'react'
import { useDialogState } from '@user/utils/useDialogState'
import { AddServiceLocationButtonProps } from './typings'
import { AddServiceLocationDrawer } from './AddServiceLocationDrawer'
import { LinkButton } from '@sales-center/components'

export const AddServiceLocationButton: React.FC<
  AddServiceLocationButtonProps
> = (props) => {
  const [open, onOpen, onClose] = useDialogState()

  return (
    <>
      <LinkButton
        onClick={onOpen}
        dataTestId={`add-service-location-${props.entityId}`}
      >
        Add Service Location
      </LinkButton>
      <AddServiceLocationDrawer {...props} open={open} onClose={onClose} />
    </>
  )
}
AddServiceLocationButton.displayName = 'AddServiceLocationButton'
